import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconNightVisionAuto, IconNightVisionOff, IconNightVisionOn } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';

import { useAspenLogger } from 'hooks/useAspenLogger';
import { useAspenSocket } from 'hooks/useAspenSocket';

import { AppLeaf } from 'types/common/leaf';
import { Settings } from 'types/aspen/settings';

interface NightVisionProps {
  leaf: AppLeaf;
}

// auto -> on -> off

const getNextNightVisionMode = (nightVisionMode: string) => {
  if (nightVisionMode === 'auto') return 'on';
  if (nightVisionMode === 'on') return 'off';
  return 'auto';
};

const nightVisionModeIconMap = {
  auto: <IconNightVisionAuto sx={{ color: colors.purple[500] }} />,
  on: <IconNightVisionOn sx={{ color: colors.purple[500] }} />,
  off: <IconNightVisionOff sx={{ color: colors.grey[400] }} />,
};

export const NightVision = ({ leaf }: NightVisionProps) => {
  const { logAspenEvent } = useAspenLogger();

  const nightVisionMode = leaf?.settings?.nightVisionMode as Settings['nightVisionMode'];
  const { updateSettings } = useAspenSocket();

  return (
    <Tooltip title="Night vision" placement="top">
      <IconButton
        aria-label="night-vision"
        data-testid="button-night-vision"
        onClick={() => {
          updateSettings({
            leaf,
            settings: { nightVisionMode: getNextNightVisionMode(nightVisionMode) },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leaf?.id,
              interaction: 'night_vision',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {nightVisionModeIconMap[nightVisionMode]}
      </IconButton>
    </Tooltip>
  );
};
